import React from 'react';
import DSAHero from '../components/DSA/hero';
import THEProblem from '../components/DSA/problem';
import WhatYouGet from '../components/DSA/what-you-get';
import Commission from '../components/DSA/commission';
import Onboarding from '../components/DSA/onboarding';
import Testimonial from '../components/DSA/testimonial';
import FAQ from '../components/Global/faqs';
import JoinDSA from '../components/DSA/join-dsa';
import PopularLoans from '../components/Home/popular-loans';

const dsaFaqs = [
  {
    id: 1,
    question: "Do I need a minimum lead volume?",
    answer:
      "No minimum lead volume is required. You can submit as few or as many leads as you generate, and earn commissions on every successful disbursal.",
  },
  {
    id: 2,
    question: "Who funds the loan?",
    answer:
      "Loans are funded either directly on Finverse's own balance sheet or routed to verified partner banks and NBFCs based on the borrower profile.",
  },
  {
    id: 3,
    question: "When do I get paid?",
    answer:
      "Commissions are disbursed on a T+7 payout cycle directly to your verified bank account once the loan is disbursed.",
  },
  {
    id: 4,
    question: "What if my lead is rejected?",
    answer:
      "If a primary lender declines the file, Finverse automatically reroutes eligible leads to alternative partner lenders to maximize approval chances.",
  },
];

export default function DSA() {
  return (
    <main>
      <div className="pt-20">
        <DSAHero />
        <THEProblem />
        <WhatYouGet />
        <Commission />
        <Onboarding />
        <Testimonial />
        <PopularLoans />
        <FAQ faqs={dsaFaqs} label="DSA FAQ" />
        <JoinDSA />
      </div>
    </main>
  );
}
